import {
  ActionProcessMode,
  CategoryName,
  ConditionSetItemsP,
  TDatasetConditionsValues,
  TFormName,
} from '@infotech-soe/metaschema';

import { CommandName } from '../CommandViewModel';
import { UserInteractor, UserInteractorType } from '../UserInteractor';
import { RefreshStrategy } from '../wrap/CategoryCommand';

import CategoryCommandImpl from './CategoryCommandImpl';

class FilterRecordsCommandImpl extends CategoryCommandImpl<ConditionSetItemsP> {
  constructor(
    private conditions: ConditionSetItemsP,
    private category: CategoryName,
    private formName: TFormName
  ) {
    super();
  }

  public async execute(): Promise<void> {
    // not implemented
  }

  public getUserInteractor(): UserInteractor {
    return {
      type: UserInteractorType.CONDITION_FORM,
      category: this.category,
      form: this.formName,
      conditions: this.conditions,
    };
  }

  public async getInitialArgs(): Promise<TDatasetConditionsValues> {
    return {};
  }

  public getName(): CommandName {
    return 'filter';
  }

  public getProcessMode(): ActionProcessMode {
    return 'Any';
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.ALL;
  }
}

export default FilterRecordsCommandImpl;
